import Vue from 'vue';
import * as errorHandler from '@/components/shared/helpers/ErrorHandler.js';
import * as AuthService from '@/services/AuthService.js';

export function putAxiosHeader () {
  Vue.axios.defaults.headers.common['Authorization'] = AuthService.token();
}

export function deletes ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = clone(argRequest);
  myRequest.filter.aplicacion = getters.externalAppId;
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: myRequest.controller,
      params: dotNotate(myRequest.filter),
      method: 'DELETE'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        // if (getters.isDebugMode) errorMessage = err;
        reject(errorMessage);
      });
  });
}

export function clone (original) {
  return JSON.parse(JSON.stringify(original));
}

export function dotNotate (obj, parent = [], keyValue = {}) {
  for (let key in obj) {
    let keyPath = [...parent, key];
    if (obj[key] !== null && typeof obj[key] === 'object') {
      Object.assign(keyValue, dotNotate(obj[key], keyPath, keyValue));
    } else {
      keyValue[keyPath.join('.')] = obj[key];
    }
  }
  return keyValue;
}

export function postSuit ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = clone(argRequest);
  myRequest.filter.aplicacion = getters.externalAppId;
  myRequest.filter.paginate = myRequest.paginate;

  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + myRequest.controller,
      data: myRequest.body,
      method: 'POST'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        errorHandler.handleRedirect(errorMessage);

        reject(errorMessage);
      });
  });
}
export function putFile ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = clone(argRequest);
  myRequest.filter.aplicacion = getters.externalAppId;
  myRequest.filter.paginate = myRequest.paginate;

  return new Promise((resolve, reject) => {
    let headersToFile = dotNotate(myRequest.filter);
    headersToFile['Content-Type'] = myRequest.contentType;
    let formData = new FormData();

    Object.keys(argRequest.body).forEach(key => {
      if (Array.isArray(argRequest.body[key]) /* && (argRequest.body[key].length > 0) */) {
        argRequest.body[key].forEach(e => {
          formData.append(key, e);
        });
      } else {
        formData.append(key, argRequest.body[key]);
      }
    });

    Vue.axios({
      url: process.env.VUE_APP_API_URL + myRequest.controller,
      data: formData,
      method: 'PUT',
      headers: headersToFile,
      processData: false
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        errorHandler.handleRedirect(errorMessage);

        reject(errorMessage);
      });
  });
}

export function postFile ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = clone(argRequest);
  myRequest.filter.aplicacion = getters.externalAppId;
  myRequest.filter.paginate = myRequest.paginate;

  return new Promise((resolve, reject) => {
    let headersToFile = dotNotate(myRequest.filter);
    headersToFile['Content-Type'] = myRequest.contentType;
    let formData = new FormData();
    Object.keys(argRequest.body).forEach(key => {
      if (Array.isArray(argRequest.body[key]) /* && (argRequest.body[key].length > 0) */) {
        argRequest.body[key].forEach(e => {
          formData.append(key, e);
        });
      } else {
        formData.append(key, argRequest.body[key]);
      }
    });

    Vue.axios({
      url: process.env.VUE_APP_API_URL + myRequest.controller,
      data: formData,
      method: 'POST',
      headers: headersToFile,
      processData: false
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        errorHandler.handleRedirect(errorMessage);

        reject(errorMessage);
      });
  });
}

export function getSuit ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = {
    params: {}
  };

  myRequest = clone(argRequest);

  let haveOpts = myRequest.opts ? myRequest.opts : null;
  let enableErrorRedirect = true;
  if (haveOpts !== null && haveOpts.hasOwnProperty('errorHandleRedirect')) enableErrorRedirect = haveOpts.enableErrorRedirect;
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + myRequest.controller,
      params: myRequest.data,
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        if (enableErrorRedirect) errorHandler.handleRedirect(errorMessage);

        reject(errorMessage);
      });
  });
}

export function getSuitBlob ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = {
    params: {}
  };

  myRequest = clone(argRequest);

  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + myRequest.controller,
      params: myRequest.data,
      method: 'GET',
      responseType: 'blob'
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function getSuitPlataforma ({ getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = {
    params: {}
  };

  myRequest = clone(argRequest);

  let haveOpts = myRequest.opts ? myRequest.opts : null;
  let enableErrorRedirect = true;
  if (haveOpts !== null && haveOpts.hasOwnProperty('errorHandleRedirect')) enableErrorRedirect = haveOpts.enableErrorRedirect;
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_PLATAFORMA_URL + myRequest.controller,
      params: myRequest.data,
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        if (enableErrorRedirect) errorHandler.handleRedirect(errorMessage);

        reject(errorMessage);
      });
  });
}

export function putSuit ({ state, getters, dispatch }, argRequest) {
  dispatch('putAxiosHeader');

  let myRequest = clone(argRequest);
  myRequest.filter.aplicacion = getters.externalAppId;
  myRequest.filter.paginate = myRequest.paginate;

  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + myRequest.controller,
      data: myRequest.body,
      method: 'PUT'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        let errorMessage = '';
        errorMessage = errorHandler.handleError(err);
        errorHandler.handleRedirect(errorMessage);

        reject(errorMessage);
      });
  });
}
